<template>
  <div></div>
</template>

<script>
export default {
  name: "baseAppComponent",
  props: ["name"],
  data() {
    return {
      moreContentDisplayed: false,
      nodesTree: {}
    };
  },
  methods: {
    select: function() {
      //event
      let that = this;
      const maskedUrl = this.$vnode.data.key;
      that.$emit("app-selected", {
        maskedUrl,
        name: this.name
      });
    },
    moreContentClicked() {
      this.moreContentDisplayed = true;
    },
    closeMoreContent() {
      this.moreContentDisplayed = false;
    }
  }
};
</script>

